<template>
    <kv-tooltip :text="tooltipText" :disabled="!showTooltip">
        <span class="invoice-status-badge" :class="statusClass">
            {{ statusLabel }}
        </span>
    </kv-tooltip>
</template>

<script>
import { computeInvoiceStatus, STATUS_LABELS } from '../helpers';
import KvTooltip from "../../components/ui/kv-tooltip.vue";

export default {
    name: "invoice-status-badge",
    components: { KvTooltip },
    props: {
        status: {
            type: String,
            required: true
        },
        dueDate: {
            type: String,
            default: null
        }
    },
    computed: {
        computedStatus() {
            return computeInvoiceStatus(this.status, this.dueDate);
        },
        statusClass() {
            return `status-${this.computedStatus}`;
        },
        statusLabel() {
            return this.t('invoices-status_' + this.computedStatus);
        },
        showTooltip() {
            return this.computedStatus === 'pending';
        },
        tooltipText() {
            return this.computedStatus === 'pending' ? this.t('invoices-slip_compensation_hint') : '';
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../helpers/status-colors';

.invoice-status-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 99px;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    @include invoice-status-modifiers;
}
</style>
